import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../components/Checkbox";
import { getProspectCompanyById } from "../../../../services/prospectCompany.service";

const Row = ({ item, selected, onSelect }) => {
    const navigate = useNavigate();
    const mainContact = item.contacts?.[0] || {};

    const handleRowClick = async () => {
        try {
            const prospectCompanyData = await getProspectCompanyById(item.id);
            navigate(`/admin/prospects_company/${item.id}`, { state: { prospectCompany: prospectCompanyData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données de l\'entreprise prospect:', error);
            navigate(`/admin/prospects_company/${item.id}`, { state: { prospectCompany: item } });
        }
    };

    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={selected}
                        onChange={(e) => {
                            e.stopPropagation();
                            onSelect && onSelect(item.id);
                        }}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <img src={item.logoUrl || '/images/content/company_logo.png'} alt="Logo" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{item.name}</div>
                            <div className={styles.login}>{item.sector}</div>
                            <div className={styles.email}>{item.representative_email}</div>
                        </div>
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.representative_email}</div>
                    <div className={styles.email}>{item.representative_phone}</div>
                </div>


                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn('status-type', 'status-green-dark')}>
                        {item.company_size}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>
                        {item.expand?.assigned_to?.name || 'Non assigné'}
                    </div>
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn('status-type', 'status-green-dark')}>
                        {item.status}
                    </div>
                </div>

            </div>
        </>
    );
};

export default Row;
